module.exports = __webpack_public_path__ + "img/yunying.daca95e1.png";